import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import config from "./config";
import _ from "lodash";
import VeeValidate, { Validator } from "vee-validate";
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
Vue.use(VeeValidate);

const dictionary = {
  en: {
    attributes: {
      email: "Sähköpostiosoite",
      etunimi: "Etunimi",
      sukunimi: "Sukunimi",
      dealer: "Jälleenmyyjä"
    },
    custom: {
      email: {
        required: "Sähköpostiosoite ei voi olla tyhjä",
        email: "Sähköpostiosoitteessa on virhe"
      },
      etunimi: {
        required: "Etunimi ei voi olla tyhjä"
      },
      sukunimi: {
        required: "Sukunimi ei voi olla tyhjä"
      },
      dealer: {
        required: "Jälleenmyyjä ei voi olla tyhjä"
      }
    }
  }
};
Validator.localize(dictionary);

Vue.config.productionTip = false;
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

window.CONF = config;
window._ = _;

router.beforeEach((to, from, next) => {
  if ("encodedStr" in to.query) {
    let q = atob(to.query.encodedStr).split("&");
    let m = {};
    _.each(q, i => {
      i = i.split("=");
      Vue.set(m, i[0], i[1]);
    });
    if ("OrderId" in m) {
      next("/order/" + m.OrderId);
    }
  }
  next();
});

// window.ga("set", "page", router.currentRoute.path);
// window.ga("send", "pageview");

// router.afterEach((to, from) => {
//   window.ga("set", "page", to.path);
//   window.ga("send", "pageview");
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
